import { Injectable } from '@angular/core';

export interface SubMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
}
export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
  children: SubMenu[];
}

const MENUITEMS = [
  { state: 'fiscalite', type: 'link', name: 'fiscalite', icon: 'request_quote', priv: 'rd_fiscalite', children: [] },
  { state: 'fiscalite/month-preview', type: 'link', name: 'monthPreview', icon: 'calendar_month', priv: 'rd_fiscalite', children: [] },
  { state: 'fiscalite/batch-form', type: 'link', name: 'Création en Lot', icon: 'library_add', priv: 'rd_fiscalite', children: [] },
 
];

@Injectable()
export class MenuItemsFiscalite {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
